const formatDate = (date, lang) => {
  const newDate = new Date(date);

  return newDate.toLocaleString(lang, {
    month: "long",
    year: "numeric"
  });
};

export default formatDate;
